/** Mirrors airportliner_be routes/dispo.js + models/vehicle.js (vehicle part). */
export type MercedesStatus = 'NONE' | 'CONNECTING' | 'CONNECTED' | 'DISCONNECTING';

export type ServiceStatus = 'ACTIVE' | 'ACTIVATION_PENDING' | 'ACTIVATION_FAILED' | 'NOT_AVAILABLE' | 'INACTIVE';

/** Row of GET /dispo/vehicles — never carries the VIN. */
export interface Vehicle {
    id: string;
    /** What the UI shows as the vehicle's name. BE-derived (currently the plate) — always display this, never compose it. */
    displayName: string;
    licensePlate: string;
    notes: string | null;
    available: boolean;
    mercedesStatus: MercedesStatus;
}

/** GET /dispo/vehicles/:id (VEHICLE_EDIT only). */
export interface VehicleDetail extends Vehicle {
    vin: string;
}

export interface VehicleInput {
    licensePlate: string;
    vin: string;
    notes: string | null;
}

export interface MercedesServiceStatus {
    serviceId: string;
    serviceName: string;
    status: ServiceStatus;
}

/** Mercedes OpenAPI VIN pattern: 17 chars, no I/O/Q, last four digits (BE validates the same). */
export const VIN_PATTERN = '^[A-HJ-NPR-Z0-9]{13}[0-9]{4}$';
